import { render } from "./ElementCategories.vue?vue&type=template&id=4c73e53e&scoped=true"
import script from "./ElementCategories.vue?vue&type=script&lang=js"
export * from "./ElementCategories.vue?vue&type=script&lang=js"

import "./ElementCategories.vue?vue&type=style&index=0&id=4c73e53e&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/G23/web-portal/bia-webportal-prod/bia-cms-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c73e53e"]])

export default __exports__